///<reference path="../../../../../../../typings/globals/angular/index.d.ts"/>
///<reference path="../../../../models/meevo.model.custom.ts"/>

module Meevo.Components.Controls.SmartMover {

    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;

    class CollectionRowsController implements ng.IComponentController {
        get objectStateEnum() {
            return ObjectStateEnum
        }

        onChangedCallback(model: ISmartMoverModel<any>) {
            if (model.disabled) return;

            if (typeof model.collection.onModelValueChangedSoft === 'function') {
                model.collection.onModelValueChangedSoft();
            }
        }
    }

    angular.module('meevo.components.controls.SmartMover')
        .component('meevoSmartMoverCollection', {
            templateUrl: 'app/components/controls/smart-mover/components/collection-row/collection-rows.html',
            controllerAs: '$ctrl',
            bindings: {
                models: '='
            },
            controller: CollectionRowsController
        });
}
